import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=bc9e112c&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=ts&"
export * from "./Form.vue?vue&type=script&lang=ts&"
import style0 from "./Form.vue?vue&type=style&index=0&id=bc9e112c&prod&scoped=true&lang=css&"
import style1 from "./Form.vue?vue&type=style&index=1&id=bc9e112c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9e112c",
  null
  
)

export default component.exports